export interface CachedSidebarPermissions {
    roles: any[];
    permissions: any[];
    tripAccess: boolean;
    staff?: any;
    firstName?: string;
    lastName?: string;
    middleName?: string;
    email?: string;
    companyName?: string;
    userId?: number | string;
}

const keyFor = (userId: number | string) => `sidbarPermissions_${userId}`;


export const saveSidebarPermissionsToCache = (userId: number| string, userProfile: any) =>{
    if(!userId) return;

    try{
        const cachedPermissions: CachedSidebarPermissions = {
            roles: userProfile?.user?.roles ?? [],
            permissions: userProfile?.user?.permissions ?? [],
            tripAccess: userProfile?.user?.tripAccess,
            staff: userProfile?.user?.staff,

            firstName: userProfile?.user?.firstName,
            lastName: userProfile?.user?.lastName,
            middleName: userProfile?.user?.middleName,
            email: userProfile?.user?.email,
            companyName: userProfile?.user?.company?.companyName,
            userId: userProfile?.user?.userId,
        };

        localStorage.setItem(keyFor(userId), JSON.stringify(cachedPermissions));
        localStorage.setItem("last_user_id", String(userId));
    }catch{
    }
}

export const loadSidebarPermissions = (): CachedSidebarPermissions | null => {
    try {
        const userId = localStorage.getItem("last_user_id");
        if(!userId) return null;
        const cachedPermissions = localStorage.getItem(keyFor(userId));
        return cachedPermissions ? JSON.parse(cachedPermissions) : null;
    } catch{
        return null
    }
}

export const clearSidebarPermissions = () => {
    const userId = localStorage.getItem("last_user_id");
    if(userId){
        localStorage.removeItem(keyFor(userId));
        localStorage.removeItem("last_user_id");
    }
}